// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CachingConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Button from 'share/components/controls/Izenda.Button';
import Alert from 'share/components/controls/Izenda.Alert';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import CachingConfigInput from './Izenda.CachingConfigInput';
import action from './Izenda.CachingConfigurationAction';
import uiState from 'logic/Izenda.UiState';
import Panel from 'share/components/controls/Izenda.Panel';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import SettingActionHeader from '../Izenda.SettingActionHeader';

@connect(action)
export default class CachingConfiguration extends Component {
  renderDataCachingConfigurationContent = () => {
    const {
      localization,
      store: {
        cachingConfiguration: { dataCachingConfiguration }
      },
      onChangeDataCacheSetting: onChange,
      validation: valManager
    } = this.props;
    const timeUnitText = localization.getText('CACHING_TIME_UNIT');
    const refreshTooltip = localization.getText('PERFORMANCE_RESET_TO_DEFAULT');
    const {
      isEnableDataCache,
      timeToLive,
      evictionInterval,
      refreshInterval,
      refreshDuration,
      defaultTimeToLive,
      defaultEvictionInterval,
      defaultRefreshInterval,
      defaultRefreshDuration
    } = dataCachingConfiguration;
    const group = 'DataCacheSetting';
    return (
      <Panel
        header={localization.getText('DATA_CACHING_CONFIGURATION_LABEL')}
        className='panel-default Izenda_CachingInfo'
      >
        <GridLayout>
          <GridLayout.Col cols={1} />
          <GridLayout.Col cols={11}>
            <CachingConfigInput
              title={localization.getText('DATA_CACHING_ENABLE_DATA_CACHE')}
              type='checkbox'
              notHaveRefresh
              dataKey='isEnableDataCache'
              notHaveTooltip
              value={isEnableDataCache}
              onChange={onChange}
              isEnableDataCache={isEnableDataCache}
            />
            {isEnableDataCache && (
              <div className='Izenda_CachingSettings'>
                <CachingConfigInput
                  title={localization.getText('DATA_CACHING_TTL')}
                  timeUnitText={timeUnitText}
                  tooltipText={localization.getText('DATA_CACHING_TTL_TOOLTIP')}
                  dataKey='timeToLive'
                  type='numeric'
                  value={timeToLive}
                  onChange={onChange}
                  defaultValue={defaultTimeToLive}
                  group={group}
                  refreshTooltip={refreshTooltip}
                  valManager={valManager}
                />
                <CachingConfigInput
                  title={localization.getText('DATA_CACHING_EVICTION_INTERVAL')}
                  timeUnitText={timeUnitText}
                  tooltipText={localization.getText('DATA_CACHING_EVICTION_INTERVAL_TOOLTIP')}
                  dataKey='evictionInterval'
                  type='numeric'
                  value={evictionInterval}
                  onChange={onChange}
                  defaultValue={defaultEvictionInterval}
                  group={group}
                  refreshTooltip={refreshTooltip}
                  valManager={valManager}
                />
                <CachingConfigInput
                  title={localization.getText('DATA_CACHING_REFRESH_INTERVAL')}
                  timeUnitText={timeUnitText}
                  tooltipText={localization.getText('DATA_CACHING_REFRESH_INTERVAL_TOOLTIP')}
                  dataKey='refreshInterval'
                  type='numeric'
                  value={refreshInterval}
                  onChange={onChange}
                  defaultValue={defaultRefreshInterval}
                  group={group}
                  refreshTooltip={refreshTooltip}
                  valManager={valManager}
                />
                <CachingConfigInput
                  title={localization.getText('DATA_CACHING_REFRESH_DURATION')}
                  timeUnitText={timeUnitText}
                  tooltipText={localization.getText('DATA_CACHING_REFRESH_DURATION_TOOLTIP')}
                  dataKey='refreshDuration'
                  type='numeric'
                  value={refreshDuration}
                  onChange={onChange}
                  defaultValue={defaultRefreshDuration}
                  group={group}
                  refreshTooltip={refreshTooltip}
                  valManager={valManager}
                />
              </div>
            )}
          </GridLayout.Col>
        </GridLayout>
      </Panel>
    );
  };

  renderSystemCachingConfigurationContent = () => {
    const {
      localization,
      store: {
        cachingConfiguration: { systemCachingConfiguration }
      },
      onChangeSystemCacheSetting: onChange,
      validation: valManager
    } = this.props;
    const timeUnitText = localization.getText('CACHING_TIME_UNIT');
    const refreshTooltip = localization.getText('PERFORMANCE_RESET_TO_DEFAULT');
    const { isEnableSystemCache,timeToLive, evictionInterval, defaultTimeToLive, defaultEvictionInterval } = systemCachingConfiguration;
    const group = 'SystemCacheSetting';
    return (
      <Panel
        header={localization.getText('SYSTEM_CACHING_CONFIGURATION_LABEL')}
        className='panel-default Izenda_CachingInfo'
      >
        <GridLayout>
          <GridLayout.Col cols={1} />
          <GridLayout.Col cols={11}>
            <CachingConfigInput
              title={localization.getText('SYSTEM_CACHING_ENABLE_SYSTEM_CACHE')}
              type='checkbox'
              notHaveRefresh
              dataKey='isEnableSystemCache'
              notHaveTooltip
              value={isEnableSystemCache}
              onChange={onChange}
              isEnableSystemCache={isEnableSystemCache}
            />
          {isEnableSystemCache && (
            <div className='Izenda_CachingSettings'>
              <CachingConfigInput
                title={localization.getText('SYSTEM_CACHING_TTL')}
                timeUnitText={timeUnitText}
                tooltipText={localization.getText('SYSTEM_CACHING_TTL_TOOLTIP')}
                dataKey='timeToLive'
                type='numeric'
                value={timeToLive}
                onChange={onChange}
                defaultValue={defaultTimeToLive}
                group={group}
                refreshTooltip={refreshTooltip}
                valManager={valManager}
              />
              <CachingConfigInput
                title={localization.getText('SYSTEM_CACHING_EVICTION_INTERVAL')}
                timeUnitText={timeUnitText}
                tooltipText={localization.getText('SYSTEM_CACHING_EVICTION_INTERVAL_TOOLTIP')}
                dataKey='evictionInterval'
                type='numeric'
                value={evictionInterval}
                onChange={onChange}
                defaultValue={defaultEvictionInterval}
                group={group}
                refreshTooltip={refreshTooltip}
                valManager={valManager}
              />
            </div>
             )}
             </GridLayout.Col>
        </GridLayout>
      </Panel>
    );
  };

  componentDidMount() {
    const { store, loader } = this.props;
    uiState.updateDisableSystemSetting();
    store.init();
    loader.startLoading();
    store.loadCachingConfiguration().finally(loader.endLoading.bind(loader));
  }

  render() {
    return (
      <div className='izenda-CachingConfig'>
        <ScrollBox fullWidth>
          <SettingActionHeader {...this.props} />
          {this.renderSystemCachingConfigurationContent()}
          {this.renderDataCachingConfigurationContent()}
        </ScrollBox>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Caching/Izenda.CachingConfiguration.js